module.exports = __webpack_public_path__ + "img/bear.be5030ca.webp";